<script setup lang="ts">
  import { MpCard, MpText } from '@borg/ui';

  const projectConfig = useProjectConfig();
</script>

<template>
  <MpCard
    v-if="projectConfig.features.ppi.enabled"
    shadow
    border
    class="container no-print"
  >
    <div>
      <MpText
        as="h5"
        :bold="false"
        regular
        style="margin-bottom: 12px"
      >
        <i18n-t
          keypath="PPI.TITLE"
          scope="global"
        >
          <template #title_highlight>
            <MpText
              no-margin
              type="h5"
            >
              {{ $t('PPI.TITLE_HIGHLIGHT') }}
            </MpText>
          </template>
        </i18n-t>
      </MpText>
      <MpText
        type="body2"
        no-margin
        shade="50"
      >
        {{ $t('PPI.SUBTITLE') }}
      </MpText>
    </div>
    <a
      class="container__button-outer"
      :href="projectConfig.features.ppi.buttonUrl"
      target="_blank"
    >
      <div class="container__button-inner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M13.5 8L18 12.5M18 12.5L13.5 17M18 12.5H6"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="container__button-text">
          {{ $t('PPI.BUTTON') }}
        </div>
      </div>
    </a>
    <a
      :href="projectConfig.features.ppi.baseUrl"
      target="_blank"
    >
      <Illustration
        image="ppi"
        height="25"
      />
    </a>
  </MpCard>
</template>

<style scoped lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: var(--mp-space-60);

    &__button-outer {
      display: flex;
      height: 40px;
      padding: var(--mp-space-20, 4px) var(--mp-space-50, 16px) var(--mp-space-20, 4px) 13px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: var(--mp-space-30, 8px);
      border-radius: var(--mp-radius-30, 10px);
      background: #ff453b;
      text-decoration: none;
    }

    &__button-inner {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    &__button-text {
      color: var(--mp-color-grey-white, #fff);
      text-align: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
</style>
